import { fromEvent } from 'rxjs';
import { utourZondaLogoSvgElement } from '../constants/svgIcons';

export default class Footer {
  classAttr =
    'nhs-c-self-guided-modal__footer nhs-mq-self-guided-modal__footer--large';

  primaryButton = null;

  secondaryButton = null;

  /**
   * Binds event listeners to the primary and secondary buttons used in the self-guided tour.
   * Initializes observables for handling click events on these buttons.
   *
   * @property {HTMLElement} primaryButton - The primary button element for the self-guided tour.
   * @property {HTMLElement} secondaryButton - The secondary button element for the self-guided tour.
   * @property {Observable} onPrimaryButtonClick$ - Observable for the primary button's click events.
   * @property {Observable} onSecondaryButtonClick$ - Observable for the secondary button's click events.
   */
  bindEvents() {
    this.primaryButton = Footer.getPrimaryButton();
    this.secondaryButton = document.querySelector(
      `button[data-self-guided-tour-secondary-button]`
    );

    this.onPrimaryButtonClick$ = fromEvent(this.primaryButton, 'click');
    this.onSecondaryButtonClick$ = fromEvent(this.secondaryButton, 'click');
  }

  setPrimaryButtonDisabled(disabled) {
    if (!this.primaryButton.isConnected) {
      this.primaryButton = Footer.getPrimaryButton();
    }

    if (this.primaryButton) {
      this.primaryButton.disabled = disabled;
    }
  }

  static getPrimaryButton() {
    return document.querySelector(
      `button[data-self-guided-tour-primary-button]`
    );
  }

  setSecondaryButtonDisabled(disabled) {
    if (this.secondaryButton) {
      this.secondaryButton.disabled = disabled;
    }
  }

  setPrimaryButtonText(text) {
    if (this.primaryButton) {
      this.primaryButton.innerText = text;
    }
  }

  setSecondaryButtonText(text) {
    if (this.secondaryButton) {
      this.secondaryButton.innerText = text;
    }
  }

  hidePrimaryButton() {
    if (this.primaryButton) {
      this.primaryButton.hidden = true;
    }
  }

  showPrimaryButton() {
    if (this.primaryButton) {
      this.primaryButton.hidden = false;
    }
  }

  hideSecondaryButton() {
    if (this.secondaryButton) {
      this.secondaryButton.hidden = true;
    }
  }

  showSecondaryButton() {
    if (this.secondaryButton) {
      this.secondaryButton.hidden = false;
    }
  }

  render() {
    return `
     <footer class="${this.classAttr}">
       <div class="nhs-c-self-guided-logo">
         ${utourZondaLogoSvgElement}
       </div>
       <div class="nhs-c-self-guided-footer-dock nhs-mq-self-guided-footer-dock--mobile">
         <button type="button"
          data-self-guided-tour-secondary-button
           class="nhs-c-button--secondary nhs-c-button--text-only nhs-o-flex-row-items-center-justify-center nhs-c-button--large-48 nhs-c-button--full nhs-mq-button--200-large">
            Call for assistance
          </button>
         <button type="button" autofocus 
            data-self-guided-tour-primary-button
           class="nhs-c-button--primary-ui nhs-c-button--text-only nhs-o-flex-row-items-center-justify-center nhs-c-button--large-48 nhs-c-button--full nhs-mq-button--200-large"
            disabled>
          Continue 
         </button>
       </div>
     </footer>
     `;
  }
}
